import React from 'react';
import navLogo from '../../../assets/images/game-bts/nav-logo.webp';
import partnerFoodplace from '../../../assets/images/game-bts/partners/Asset-1.png';
import partnerMini from '../../../assets/images/game-bts/partners/Asset-2.png';
import partnerPure from '../../../assets/images/game-bts/partners/Asset-3.png';
import partnerMarket from '../../../assets/images/game-bts/partners/Asset-4.png';
import partnerHyper from '../../../assets/images/game-bts/partners/Asset-5.png';
import './ReceiptHistoryItem.css';

const PARTNER_LOGOS = {
  '50': partnerHyper,
  '450': partnerHyper,
  '100': partnerMini,
  '150': partnerHyper,
  '200': partnerFoodplace,
  '250': partnerMarket,
  '01': partnerPure,
};

const PARTNER_NAMES = {
  '50': 'Big C Hyper',
  '450': 'Big C Hyper',
  '100': 'Big C Hyper',
  '150': 'Big C Hyper',
  '200': 'Big C Hyper',
  '250': 'Big C Hyper',
  '01': 'Big C Hyper',
};

const CANCEL_REASONS = {
  RETURNED: 'ลูกค้าได้ยกเลิกบิลนี้ (คืนสินค้า)',
  CANCELLED: 'ใบเสร็จนี้ถูกยกเลิกโดยระบบ',
  NOT_MATCH: 'BigPoint ไม่ตรงกับใบเสร็จ',
};

const ReceiptHistoryItem = ({ item }) => {
  const logo = PARTNER_LOGOS[item.partnerId] || navLogo;
  const partnerName = PARTNER_NAMES[item.partnerId] || 'Big C Hyper';
  const isCancelled = item.reconcileStatus === 'RETURNED' || item.reconcileStatus === 'CANCELLED' || item.reconcileStatus === 'NOT_MATCH';
  const cancelReason = CANCEL_REASONS[item.reconcileStatus] || null;

  return (
    <div className={`bts-receipt ${isCancelled ? 'bts-receipt--cancelled' : ''}`}>
      <div className="bts-receipt__icon-box">
        <img src={logo} alt="partner" className="bts-receipt__icon-img" />
      </div>

      <div className="bts-receipt__info">
        <p className="bts-receipt__code">
          เลขบิล: {item.txCode}
          {isCancelled && <span className="bts-receipt__cancel-badge">ยกเลิก</span>}
        </p>
        <p className="bts-receipt__store">{item.storeName || partnerName}</p>
        {cancelReason && <p className="bts-receipt__cancel-reason">{cancelReason}</p>}
        <p className="bts-receipt__meta">{item.date}</p>
      </div>

      <div className="bts-receipt__right">
        <div className="bts-receipt__points-row">
          {isCancelled ? (
            <p className="bts-receipt__points bts-receipt__points--cancelled">-{item.points}</p>
          ) : (
            <p className="bts-receipt__points">+{item.points}</p>
          )}
          {!isCancelled && item.multiplier > 1 && (
            <span className="bts-receipt__multiplier">x{item.multiplier}</span>
          )}
        </div>
        <span className="bts-receipt__pts-unit">{isCancelled ? 'คะแนนยกเลิก' : 'คะแนน'}</span>
      </div>
    </div>
  );
};

export default ReceiptHistoryItem;
